import React from 'react';
import PropTypes from 'prop-types';
import styles from './MessageBubble.module.scss';

const MessageBubble = ({ message }) => {

  const formatTime = (id) => {
    const parsedDate = new Date(id)

    return parsedDate.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div
      className={`${styles.messageWrapper} ${message.type === 'user' ? styles.messageWrapperUser : ''}`}
    >
      <div className={styles.messageContent}>
        <div className={`${styles.messageBubble} ${message.type === 'user' ? styles.userMessage : styles.botMessage}`}>
          <div>
            <p className={styles.messageText}>{message.text || 'No message content'}</p>
            {message.hasValidModel && (
              <div className={styles.modelIndicator}>
                ✅ YAML Model Generated
              </div>
            )}
          </div>
          
          {message.fileNames && message.fileNames.length > 0 && (
            <div className={styles.attachedFileList}>
              <div className={styles.attachedFileItem}>
                📎 {message.fileNames.length} {message.fileNames.length === 1 ? 'file' : 'files'}: {message.fileNames.join(', ')}
              </div>
            </div>
          )}
        </div>
        <p className={`${styles.messageTime} ${message.type === 'user' ? styles.messageTimeUser : ''}`}>
          {formatTime(message.id)}
        </p>
      </div>
    </div>
  );
};

MessageBubble.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    type: PropTypes.oneOf(['user', 'bot']).isRequired,
    text: PropTypes.string,
    fileNames: PropTypes.arrayOf(PropTypes.string),
    hasValidModel: PropTypes.bool
  }).isRequired
};

export default MessageBubble;